<template>
  <div :class="fullWidth ? 'w-full': '' ">
    <div v-for="index in count" :key="index">
      <b-skeleton class="dashboard-skeleton" :type="type" :style="`height:${height};width:${width} `" :class="{'mb-3': (index < count - 1) }" :animation="animation || 'throb'" width="100%"></b-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom-skeleton',
  props: {
    count: {
      type: Number,
      required: true
    },
    height: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    },
    animation: {
      type: String,
      required: false
    },
    fullWidth: {
      type: Boolean,
      required: false
    },
  }
};
</script>

<style scoped lang="scss">
.dashboard-skeleton{
  background-color: rgba(255, 255, 255, .2) !important;
}
</style>